import * as actionTypes from "../constants/persist";
const initialState={
    forum_auth:{
        canView:true,
        canPost:true,
        canComment:true,
        canReply:true,
        canVote:true,
        canFlag:true,
        canMark:true,
    },
    firstvisit_topic:true,
    forum_id:0,
    forum_sort:1,
    comment_sort:1,
    filter_action:'',
    channel_id:0,
    forum_name:'',
    recent_search:[],
    is_auth_qubisa:false,
}
const  reducer= (state=initialState,action)=>{
    switch (action.type) {
        case actionTypes.SET_PERSIST:
            return{
                ...state,
                [Object.keys(action.payload)]:Object.values(action.payload)[0]
            }
        case actionTypes.RESET_PERSIST:
            return state=initialState
        default:
            return state;
    }
}

export default reducer